<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('expensePosting.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('expensePosting.pageTitle'),
            href: '/admin/expense-postings'
          },
          {
            text: $t('create'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="ts-p-2 ts-rounded-md">
          <div
            class="ts-w-full ts-h-full ts-border-2 ts-border-dashed ts-rounded-md ts-p-3 ts-relative"
          >
            <BasicInfo v-model="model" :validate="errors" ref="basicInfo" />
          </div>
        </div>
        <div class="ts-p-2 ts-rounded-md">
          <div
            class="ts-w-full ts-h-full ts-border-2 ts-border-dashed ts-rounded-md ts-p-3 ts-relative"
          >
            <Detail v-model="model" :validate="errors" />
          </div>
        </div>
      </ts-card-wrapper>
      <ts-card-wrapper>
        <div class="row">
          <div
            class="col-md-12 ts-flex ts-items-center ts-justify-end ts-space-x-3"
          >
            <ts-button
              :disabled="loading"
              @click.prevent="$router.push({ name: 'expense-posting' })"
              >{{ $t('cancel') }}
            </ts-button>
            <ts-button
              :disabled="loading"
              color="primary"
              @click.prevent="onUpdate"
            >
              {{ $t('update') }}</ts-button
            >
          </div>
        </div>
      </ts-card-wrapper>
    </ts-card>
    <Spin size="large" fix v-if="loading"></Spin>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import BasicInfo from './components/basic-info.vue'
import Detail from './components/detail.vue'
import { mapState, mapActions } from 'vuex'
import moment from 'moment'
import { isEmpty } from 'lodash'

export default {
  name: 'edit',
  components: {
    BasicInfo,
    Detail
  },
  data() {
    return {
      errors: new Errors(),
      loading: false,
      waiting: false,
      model: {
        exp_main_id: null,
        exp_date: moment().format('DD-MM-YYYY'),
        expense_type: 0,
        expense_status: 1,
        currency_id: null,
        fx_rate: null,
        fx_rate_ratio: null,
        grand_total: null,
        advance_id: null,
        advance_status: null,
        advance_amount: null,
        reimburse_by: null,
        reimburse_amount: null,
        remarks: null,
        payment_method_id: 1,
        bank_name: null,
        account_name: null,
        account_number: null,
        details: [],
        document_attacheds: []
      }
    }
  },
  computed: {
    ...mapState('expense/expensePosting', ['formViewDatas', 'edit_data'])
  },
  methods: {
    ...mapActions('expense/expensePosting', [
      'getFormViewModel',
      'find',
      'update'
    ]),
    async getPreData() {
      this.loading = true
      await this.find(this.$route.params.id).then(() => {
        this.setEditData()
      })
      await this.getFormViewModel({
        index: undefined,
        params: {
          product_id: this.model.details.map(el => el.product_id),
          advance_id: this.model.advance_id
        }
      })
      this.errors = new Errors()
      this.loading = false
    },
    async onUpdate() {
      this.loading = true
      await this.$refs.basicInfo.onUploadDocumentAttached()
      this.update({
        id: this.edit_data.exp_main_id,
        data: this.model
      })
        .then(response => {
          this.$toasted.success(response.message)
          this.$router.push({ name: 'expense-posting' })
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.loading = false
        })
    },
    clearInput() {
      this.model.exp_main_id = null
      this.model.exp_date = moment().format('DD-MM-YYYY')
      this.model.expense_type = 0
      this.model.expense_status = 0
      this.model.currency_id = null
      this.model.fx_rate = null
      this.model.fx_rate_ratio = null
      this.model.grand_total = null
      this.model.advance_id = null
      this.model.advance_status = null
      this.model.advance_amount = null
      this.model.reimburse_by = null
      this.model.reimburse_amount = null
      this.model.remarks = null
      this.model.payment_method_id = 1
      this.model.bank_name = null
      this.model.account_name = null
      this.model.account_number = null
      this.model.details = []
      this.$store.commit('expense/expensePosting/SET_EDIT_DATA', {})
    },
    async setEditData() {
      if (!isEmpty(this.edit_data)) {
        this.model.exp_main_id = this.edit_data.exp_main_id
        this.model.exp_date = this.edit_data.exp_date
        this.model.expense_type = this.edit_data.expense_type
        this.model.expense_status = this.edit_data.expense_status
        this.model.currency_id = this.edit_data.currency_id
        this.model.fx_rate = this.edit_data.fx_rate
        this.model.fx_rate_ratio = this.edit_data.fx_rate_ratio
        this.model.grand_total = this.edit_data.grand_total
        this.model.advance_id = this.edit_data.advance_id
        this.model.advance_amount = this.edit_data.advance_amount
        this.model.reimburse_by = this.edit_data.reimburse_by
        this.model.reimburse_amount = this.edit_data.reimburse_amount
        this.model.remarks = this.edit_data.remarks
        this.model.payment_method_id = this.edit_data.payment_method_id
        this.model.bank_name = this.edit_data.bank_name
        this.model.account_name = this.edit_data.account_name
        this.model.account_number = this.edit_data.account_number

        this.model.document_attacheds = this.edit_data.document_attacheds.map(
          el => ({
            id: el.id,
            uid: el.id,
            name: el.name,
            status: 'done',
            file_path: el.file_path,
            mime_type: el.mime_type,
            size: el.size,
            url: el.file_path
          })
        )
        this.model.details = this.edit_data.details.map(el => ({
          exp_detail_id: el.exp_detail_id,
          exp_id: el.exp_id,
          expense_by: el.expense_by,
          purpose: el.purpose,
          vendor: el.vendor,
          product_id: el.product_id,
          serial_no: el.serial_no,
          uom_id: el.uom_id,
          input_currency_id: el.input_currency_id,
          currency_id: el.currency_id,
          fx_rate: el.fx_rate,
          fx_rate_ratio: el.fx_rate_ratio,
          quantity: el.quantity,
          input_unit_price: el.input_unit_price,
          unit_price: el.unit_price,
          input_total: el.input_total,
          total: el.total,
          order: el.order
        }))
      }
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.getPreData()
    })
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('expense/expensePosting/SET_EDIT_DATA', {})
    next()
  }
}
</script>
<style scoped>
* {
  font-family: Roboto, Khmer, 'Font Awesome 5 Free';
}
</style>
